import { UserLogoutWrapperProps } from '@msc-b2c/interfaces/types';
import UserLogout from './components/UserLogout';
import ShoppingCart from './components/ShoppingCart';
import styles from './userLogoutWrapper.module.scss';

export function UserLogoutWrapper({
  userIcon,
  usernameLabel,
  logoutIcon,
  fullLogoutLabel,
  lightLogoutLabel,
  logoutLink,
  shoppingCartIcon,
  shoppingCartIconAriaLabel,
  showShoppingCart,
}: Readonly<UserLogoutWrapperProps>) {
  const userLogoutProps = {
    userIcon,
    usernameLabel,
    logoutIcon,
    fullLogoutLabel,
    lightLogoutLabel,
    logoutLink,
  };
  const shoppingCartProps = {
    shoppingCartIcon,
    shoppingCartIconAriaLabel,
  };

  return (
    <div className={styles.userLogoutWrapper}>
      <UserLogout {...userLogoutProps} />
      {showShoppingCart && <ShoppingCart {...shoppingCartProps} />}
    </div>
  );
}
export default UserLogoutWrapper;

UserLogoutWrapper.aemResourceType = 'b2c-website-foundation/components/mymsc/userlogout';
